module.exports = __webpack_public_path__ + "img/the-safe-hover.91909154.png";